/**
 * Alias for {@link useLocalStorage} — same API, clearer name when used as persisted UI state.
 */
export { useLocalStorage as useLocalStorageState } from "@/lib/useLocalStorage";
